(() => {
  const closeButtonSelector = '.notification__close';

  const addCloseButton = (toast) => {
    if (!(toast instanceof Element) || !toast.matches('.notification--sticky')) return;
    if (toast.querySelector(closeButtonSelector)) return;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'notification__close';
    button.setAttribute('aria-label', 'Dismiss notification');
    button.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke-linecap="round" stroke-width="2"></path>
      </svg>
    `;

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      toast.click();
    });

    toast.appendChild(button);
  };

  const start = () => {
    document.querySelectorAll('.notification--sticky').forEach(addCloseButton);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          addCloseButton(node);
          node.querySelectorAll('.notification--sticky').forEach(addCloseButton);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
